"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncomeDocumentUuid = exports.toBusinessOwnershipVerificationJobId = exports.isBusinessOwnershipVerificationJobId = exports.DocumentAckOwnerArn = exports.buildAltcoinMachineArgosAccountLabel = exports.buildArgosAccountLabel = exports.MethodFiCreditScoreId = exports.MethodFiEntityId = exports.GalileoAccountNumber = exports.CoreCardAccountNumber = void 0;
const assert_1 = __importDefault(require("assert"));
/**
 * Factory that produces isValid / id helpers for a branded string ID type.
 *
 * Usage (for each new branded type):
 *   1. Declare a unique symbol + brand type for compile-time distinctness
 *   2. Export a type alias:  export type Foo = BrandedStringId<FooBrandType>
 *   3. Export a const:       export const Foo = createBrandedStringIdHelpers<FooBrandType>(pattern, 'Foo')
 *
 * Don't export this, just use it for each BrandedType in here
 */
const createBrandedStringIdHelpers = (pattern, typeName) => ({
    isValid: (raw) => {
        return typeof raw === 'string' && pattern.test(raw);
    },
    id: (raw, options) => {
        if (!options?.isFake) {
            (0, assert_1.default)(pattern.test(raw), `${raw} is not a valid ${typeName}`);
        }
        return raw;
    },
});
const UUID_V4_PATTERN_STRING = '[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}';
exports.CoreCardAccountNumber = createBrandedStringIdHelpers(/^911[0-9]{13}$/, 'CoreCardAccountNumber');
exports.GalileoAccountNumber = createBrandedStringIdHelpers(/^693[0-9]{9}$/, 'GalileoAccountNumber');
exports.MethodFiEntityId = createBrandedStringIdHelpers(/^ent_[A-Za-z0-9]+$/, 'MethodFiEntityId');
exports.MethodFiCreditScoreId = createBrandedStringIdHelpers(/^crs_[A-Za-z0-9]+$/, 'MethodFiCreditScoreId');
const loanApplicationArgosAccountLabelHelpers = createBrandedStringIdHelpers(/^loan-application-[0-9]+$/, 'LoanApplicationArgosAccountLabel');
/** The only way to construct a LoanApplicationArgosAccountLabel — formats and brands from a loan application id. */
const buildArgosAccountLabel = (loanApplicationId) => loanApplicationArgosAccountLabelHelpers.id(`loan-application-${loanApplicationId}`);
exports.buildArgosAccountLabel = buildArgosAccountLabel;
const altcoinMachineArgosAccountLabelHelpers = createBrandedStringIdHelpers(/^.+-altcoin-machine-.+$/, 'AltcoinMachineArgosAccountLabel');
/** The only way to construct an AltcoinMachineArgosAccountLabel. */
const buildAltcoinMachineArgosAccountLabel = (rawLabel) => altcoinMachineArgosAccountLabelHelpers.id(rawLabel);
exports.buildAltcoinMachineArgosAccountLabel = buildAltcoinMachineArgosAccountLabel;
exports.DocumentAckOwnerArn = createBrandedStringIdHelpers(/^arn:[a-z]+:documentAck:[a-zA-Z]+(:[a-zA-Z0-9_|-]+)?$/, 'DocumentAckOwnerArn');
({ isValid: exports.isBusinessOwnershipVerificationJobId, id: exports.toBusinessOwnershipVerificationJobId } = createBrandedStringIdHelpers(new RegExp(`^${UUID_V4_PATTERN_STRING}$`, 'i'), 'BusinessOwnershipVerificationJobId'));
/** @TranslateToPython */
const INCOME_DOCUMENT_UUID_PREFIX = 'income_document_';
exports.IncomeDocumentUuid = createBrandedStringIdHelpers(new RegExp(`^${INCOME_DOCUMENT_UUID_PREFIX}${UUID_V4_PATTERN_STRING}$`, 'i'), 'IncomeDocumentUuid');
